import axios from "axios";
import Swal from "sweetalert2";
// import History from "../../routes/CustomHistory";
import moment from "moment";

var CryptoJS = require("crypto-js");




// -------------------------------------------------------------------------
// for opening and closing BuyerNumber settings model
// -------------------------------------------------------------------------
export const hideBuyerNumberModal=()=>{
    return {
      type:'hideBuyerNumberModal'
    }
    
    }
    export const showBuyerNumberModal=()=>{
  
      return {
        type:'showBuyerNumberModal'
      }
      
      }
  
  
      export const showEditBuyerNumberModal=()=>{
        return {
          type:'showEditBuyerNumberModal'
        }
        
        }
      
        export const hideEditBuyerNumberModal=()=>{
          return {
            type:'hideEditBuyerNumberModal'
          }
        }




// ---------------------------------------------------------------------------------------------------------
// to get all BuyerNumbers for settings
// ---------------------------------------------------------------------------------------------------------

export const getBuyerNumbers = (currentPage) => {



    return (dispatch) => {
        dispatch(getBuyerNumberStarted());
    
        const cipherToken = JSON.parse(localStorage.getItem("fkey"));
    
        var bytes = CryptoJS.AES.decrypt(cipherToken, "Ghulamm@2022");
        var decryptedToken = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    
        // //console.log(decryptedToken);
    
       
        let axiosConfig = {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Accept: "application/json",
            Authorization: `Bearer ${decryptedToken}`,
          },
  
        };
       
    
        axios
          .get(`${process.env.REACT_APP_API_ADDRESS}/BuyerNumbers?page=${currentPage}`,axiosConfig)
          .then((response) => {
            if (response.data.success_message) {
              //console.log(response.data);
              dispatch(getBuyerNumberSuccess(response.data,currentPage));
          
            } 
          })
          .catch((err) => {
            //console.log(err.response.data);
            dispatch(getBuyerNumberFailure(err.response.data.errors));
  
          });
      };
    };
    
    const getBuyerNumberStarted = () => ({
      type: "getBuyerNumber_started",
    });
    
    
    const getBuyerNumberSuccess = (data,currentPage) => ({
      type: "getBuyerNumbersSettings_success",
      payload: {
        ...data,'currentPage':currentPage,
    },
    });
    
    const getBuyerNumberFailure = (error) => ({
      type: "getBuyerNumber_failure",
      payload: {
        error,
      }, 
    });
  
  
  


// ---------------------------------------------------------------------------------------------------------
// roles register in the system with pagination Action - the authenticated role would be able to fetch list here
// ---------------------------------------------------------------------------------------------------------



export const registerBuyerNumber = (name) => {
  
  return (dispatch) => {
    dispatch(registerBuyerNumberStarted());

    const cipherToken = JSON.parse(localStorage.getItem("fkey"));

    var bytes = CryptoJS.AES.decrypt(cipherToken, "Ghulamm@2022");
    var decryptedToken = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    // //console.log(decryptedToken);

    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Accept: "application/json",
        Authorization: `Bearer ${decryptedToken}`,
      },
    };

    let BuyerNumberData={
     buyer_no:name,
    }

    axios
      .post(`${process.env.REACT_APP_API_ADDRESS}/BuyerNumberRegister`, BuyerNumberData, axiosConfig)
      .then((response) => {
        if (response.data.success_message) {

       //console.log(response.data)
          dispatch(registerBuyerNumberSuccess(response.data));

          Swal.fire({
            position: 'top-end',
            icon: 'success',
            text: 'The BuyerNumber has been succesfully registered',
            showConfirmButton: false,
            timer: 800,
            toast: true,

          })
        }
      })
      .catch((err) => {
      
        dispatch(registerBuyerNumberFailure(err.response.data.errors));
     
      });
  };
};

const registerBuyerNumberStarted = () => ({
  type: "registerBuyerNumber_started",
});

const registerBuyerNumberSuccess = (data) => ({
  type: "registerBuyerNumber_success",
  payload: {
    ...data,
  },
});

const registerBuyerNumberFailure = (error) => ({
  type: "registerBuyerNumber_failure",
  payload: {
    error,
  },
});





// ---------------------------------------------------------------------------------------------------------
// the BuyerNumber edit function will only fetch the data of a single role 
// ---------------------------------------------------------------------------------------------------------

export const BuyerNumberEdit = (id) => {

  return (dispatch) => {
    dispatch(BuyerNumberEditDetailsStarted());

    const cipherToken = JSON.parse(localStorage.getItem("fkey"));

    var bytes = CryptoJS.AES.decrypt(cipherToken, "Ghulamm@2022");
    var decryptedToken = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    // //console.log(decryptedToken);

    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Accept: "application/json",
        Authorization: `Bearer ${decryptedToken}`,
      },
    };
   
   


    axios
      .get(`${process.env.REACT_APP_API_ADDRESS}/editBuyerNumber/`+id,axiosConfig)
      .then((response) => {
        if (response.data.success_message) {
          
          //console.log(response.data)

          dispatch(BuyerNumberEditDetailsSuccess(response.data));
      
        } 
      })
      .catch((err) => {
        //console.log(err.response.data.errors);
        dispatch(BuyerNumberEditDetailsFailure(err.response.data.errors));
     
      });
  };
};

const BuyerNumberEditDetailsStarted = () => ({
  type: "BuyerNumberEditDetails_started",
});

const BuyerNumberEditDetailsSuccess = (data) => ({
  type: "BuyerNumberEditDetails_success",
  payload: {
    ...data,
  },
});

const BuyerNumberEditDetailsFailure = (error) => ({
  type: "BuyerNumberEditDetails_failure",
  payload: {
    error,
  },
});



// ---------------------------------------------------------------------------------------------------------
// the BuyerNumber update 
// ---------------------------------------------------------------------------------------------------------

export const BuyerNumberUpdate = (id,name,currentPage) => {
    return (dispatch) => {
      dispatch(BuyerNumberUpdateStarted());
  
      const cipherToken = JSON.parse(localStorage.getItem("fkey"));
  
      var bytes = CryptoJS.AES.decrypt(cipherToken, "Ghulamm@2022");
      var decryptedToken = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  
      // //console.log(decryptedToken);
  
      let axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Accept: "application/json",
          Authorization: `Bearer ${decryptedToken}`,
        },
      };
     
      let buyerNumberData={
        buyer_no:name,
       }
  
  
      axios
        .put(`${process.env.REACT_APP_API_ADDRESS}/updateBuyerNumber/`+id,buyerNumberData,axiosConfig)
        .then((response) => {
          if (response.data.success_message) {
            //console.log(response.data);
            dispatch(BuyerNumberUpdateSuccess(response.data,currentPage));
  
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              text: 'The BuyerNumber has been successfully updated ',
              showConfirmButton: false,
              timer: 800,
              toast: true,
  
            })
        
          } 
        })
        .catch((err) => {
          //console.log(err.response.data.errors);
          dispatch(BuyerNumberUpdateFailure(err.response.data.errors));
       
        });
    };
  };
  
  const BuyerNumberUpdateStarted = () => ({
    type: "BuyerNumberUpdate_started",
  });
  
  
  const BuyerNumberUpdateSuccess = (data,currentPage) => ({
    type: "BuyerNumberUpdate_success",
    payload: {
      ...data,'currentPage':currentPage,
    },
  });
  
  const BuyerNumberUpdateFailure = (error) => ({
    type: "BuyerNumberUpdate_failure",
    payload: {
      error,
    }, 
  });
  





// ---------------------------------------------------------------------------------------------------------
// BuyerNumbers Deletion
// ---------------------------------------------------------------------------------------------------------

export const BuyerNumberDelete = (id,currentPage) => {

  return (dispatch) => {
    dispatch(BuyerNumberDeletionStarted());

    const cipherToken = JSON.parse(localStorage.getItem("fkey"));

    var bytes = CryptoJS.AES.decrypt(cipherToken, "Ghulamm@2022");
    var decryptedToken = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    // //console.log(decryptedToken);

    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Accept: "application/json",
        Authorization: `Bearer ${decryptedToken}`,
      },
    };
   
   


    axios
      .delete(`${process.env.REACT_APP_API_ADDRESS}/deleteBuyerNumber/`+id,axiosConfig)
      .then((response) => {
        if (response.data.success_message) {
          
          // //console.log(response.data)

          dispatch(BuyerNumberDeletionSuccess(response.data,currentPage));

          Swal.fire({
            position: 'top-end',
            icon: 'success',
            text: 'The BuyerNumber has been successfully deleted ! ',
            showConfirmButton: false,
            timer: 800,
            toast: true,

          })
      
        } 
      })
      .catch((err) => {
        dispatch(BuyerNumberDeletionFailure(err.message));
      });
  };
};

const BuyerNumberDeletionStarted = () => ({
  type: "BuyerNumberDeletion_started",
});

const BuyerNumberDeletionSuccess = (data,currentPage) => ({
  type: "BuyerNumberDeletion_success",
  payload: {
    ...data,'currentPage':currentPage,
  },
});

const BuyerNumberDeletionFailure = (error) => ({
  type: "BuyerNumberDeletion_failure",
  payload: {
    error,
  },
});
